import React from "react"
import { Link } from "react-router-dom"
import logo from "./WaveSaleslandingpage/img/logo.png"

export default function PoliticaCookies() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900">
      {/* Header con logo */}
      <header className="bg-gray-900/50 backdrop-blur-sm border-b border-gray-700 sticky top-0 z-50">
        <div className="max-w-6xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3">
            <img src={logo} alt="WaveSales" className="h-10 w-auto" />
            <span className="text-xl font-bold text-white">WaveSales</span>
          </Link>
          <Link 
            to="/" 
            className="text-gray-300 hover:text-white transition-colors text-sm"
          >
            ← Volver al inicio
          </Link>
        </div>
      </header>

      {/* Contenido principal */}
      <main className="max-w-4xl mx-auto px-6 py-12">
        <div className="bg-white/5 backdrop-blur-md rounded-2xl border border-gray-700/50 shadow-2xl p-8 md:p-12">
          <h1 className="text-4xl font-bold text-white mb-2">
            Política de Cookies
          </h1>
          <p className="text-gray-400 text-sm mb-8">
            Última actualización: 18/11/2025
          </p>

          <div className="prose prose-invert max-w-none space-y-6 text-gray-300">
            <section>
              <h2 className="text-2xl font-semibold text-white mt-8 mb-4">¿Qué son las cookies?</h2>
              <p className="text-gray-300 leading-relaxed">
                Las cookies son archivos pequeños que se almacenan en tu dispositivo cuando visitas un sitio web. Nos ayudan a reconocer tu dispositivo y a recordar ciertas preferencias.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mt-8 mb-4">Tipos de cookies que usamos</h2>
              
              <div className="space-y-6 mt-4">
                <div className="bg-white/5 p-6 rounded-xl border border-gray-700/30">
                  <h3 className="text-xl font-semibold text-white mb-3">
                    🔒 Cookies técnicas (imprescindibles)
                  </h3>
                  <ul className="list-disc list-inside space-y-2 text-gray-300 ml-4">
                    <li>Permiten la navegación y el uso de funciones básicas (inicios de sesión, seguridad).</li>
                    <li className="text-indigo-400 font-medium">No requieren consentimiento.</li>
                  </ul>
                </div>

                <div className="bg-white/5 p-6 rounded-xl border border-gray-700/30">
                  <h3 className="text-xl font-semibold text-white mb-3">
                    ⚙️ Cookies de personalización
                  </h3>
                  <p className="text-gray-300 leading-relaxed">
                    Recordar idioma, preferencias visuales, ajustes de la cuenta.
                  </p>
                </div>

                <div className="bg-white/5 p-6 rounded-xl border border-gray-700/30">
                  <h3 className="text-xl font-semibold text-white mb-3">
                    📊 Cookies de análisis
                  </h3>
                  <ul className="list-disc list-inside space-y-2 text-gray-300 ml-4">
                    <li>Recopilan información sobre el uso del sitio (páginas visitadas, tiempo de sesión).</li>
                    <li>Usamos Google Analytics (u otro) para entender el uso y mejorar el servicio.</li>
                  </ul>
                </div>

                <div className="bg-white/5 p-6 rounded-xl border border-gray-700/30">
                  <h3 className="text-xl font-semibold text-white mb-3">
                    📢 Cookies publicitarias / de terceros
                  </h3>
                  <ul className="list-disc list-inside space-y-2 text-gray-300 ml-4">
                    <li>Pueden ser usadas por terceros (por ejemplo Meta Pixel) para personalizar publicidad fuera de nuestro sitio.</li>
                    <li className="text-yellow-400 font-medium">Su uso requiere tu consentimiento explícito (según la legislación aplicable).</li>
                  </ul>
                </div>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mt-8 mb-4">¿Cómo administrar o desactivar cookies?</h2>
              <p className="text-gray-300 leading-relaxed">
                Puedes configurar tu navegador para bloquear o eliminar cookies. Ten en cuenta que bloquear cookies puede afectar la funcionalidad del sitio.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mt-8 mb-4">Lista de cookies (ejemplos)</h2>
              <div className="bg-white/5 p-6 rounded-xl border border-gray-700/30 space-y-3">
                <div className="flex items-start gap-3">
                  <span className="text-indigo-400 font-mono text-sm">_session</span>
                  <span className="text-gray-400">— (técnica) gestión de sesión.</span>
                </div>
                <div className="flex items-start gap-3">
                  <span className="text-indigo-400 font-mono text-sm">_ga, _gid</span>
                  <span className="text-gray-400">— (analytics) Google Analytics.</span>
                </div>
                <div className="flex items-start gap-3">
                  <span className="text-indigo-400 font-mono text-sm">fbp</span>
                  <span className="text-gray-400">— (publicidad) Facebook / Meta Pixel.</span>
                </div>
              </div>
              <p className="text-gray-400 text-sm mt-4 italic">
                (Nota: actualiza la lista con las cookies concretas que tu web/servicios usan antes de publicar.)
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mt-8 mb-4">Consentimiento</h2>
              <p className="text-gray-300 leading-relaxed">
                Al usar el sitio aceptas la instalación de cookies no esenciales salvo que las rechaces mediante la configuración del navegador o el banner de cookies.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-white mt-8 mb-4">Contacto</h2>
              <p className="text-gray-300 leading-relaxed">
                Para consultas sobre cookies:{" "}
                <a href="mailto:soporte@wave-sales.com" className="text-indigo-400 hover:text-indigo-300 transition-colors">
                  soporte@wave-sales.com
                </a>
              </p>
            </section>
          </div>
        </div>
      </main>

      {/* Footer simple */}
      <footer className="bg-gray-900/50 border-t border-gray-700 py-8 mt-12">
        <div className="max-w-6xl mx-auto px-6 text-center text-gray-400 text-sm">
          <p>© 2025 WaveSales. Todos los derechos reservados.</p>
          <div className="mt-4 flex items-center justify-center gap-6">
            <Link to="/terminos-y-condiciones" className="hover:text-white transition-colors">
              Términos y condiciones
            </Link>
            <Link to="/politica-de-privacidad" className="hover:text-white transition-colors">
              Política de privacidad
            </Link>
            <Link to="/politica-de-cookies" className="hover:text-white transition-colors">
              Política de Cookies
            </Link>
          </div>
        </div>
      </footer>
    </div>
  )
}
